import {SSkuCard} from "shj-components";
import {isArray} from "lodash-es";
import styles from "@/pages/orderService/index.module.less";
import {numFormat} from "shj-components/dist/es/SFilterTable";
import {Tag} from "antd";
import {checkPicturePre} from "@/utils/file.ts";
// 状态对应标签颜色
const stateColorFn = (state:string)=>{
  let color:string = 'rgba(0, 100, 255, 1)';
  switch (state) {
    case "refunding":
      color="red";
      break;
    case "refunded":
      color="rgba(235, 55, 35, 1)";
      break;
    case 'serviceCompleted':
      color="rgba(0, 168, 101, 1)";
      break;
  }
  return color;
}
export const config = {
  // tableType:'antd',
  pagination: false,
  rowSelection: false,
  fieldControl: false,
  columns: [
    {
      title: '商品',
      dataIndex: 'name',
      key: 'name',
      width: 200,
      render: (_,record) => (
          <>
            <SSkuCard
                width={'100%'}
                url={ record?.mainPic ? checkPicturePre(record?.mainPic):undefined }
                desc={record?.name || ""}
                operation={() => {
                  return <div></div>
                }}
                title={record?.goodsCode || ""}
            ></SSkuCard>
          </>
      ),
    },
    {
      title: '规格',
      dataIndex: 'format',
      key: 'format',
      width: 160,
      render: (val: any) => {
        if(!val||!val.includes('['))return "";
        return <>
          {isArray(JSON.parse(val))&&JSON.parse(val).length>0&&JSON.parse(val).map(item => {
            return (
                <>
                  <div style={{wordBreak: 'break-all'}}>{item?.argName}:{item?.argValName}</div>
                </>
            );
          })}
        </>
      },
    },
    {
      title: '需求标签',
      dataIndex: 'bizTagDisplay',
      key: 'bizTagDisplay',
      width:100,
    },
    {
      title: '品牌',
      dataIndex: 'brandName',
      key: 'brandName',
      width:90,
    },
    {
      title: '单位',
      dataIndex: 'unitName',
      key: 'unitName',
      width:90,
    },
    {
      title: '单价',
      dataIndex: 'unitPrice',
      key: 'unitPrice',
      width:90,
    },
    {
      title: '数量',
      dataIndex: 'number',
      key: 'number',
      width:90,
    },
    {
      title: '合计价格',
      dataIndex: 'totalPrice',
      key: 'totalPrice',
      width:120,
      render: (val) => (
          <>
            <div className={styles.redColor}>￥{ val?`${numFormat({ value: val })}`:'0.00'}</div>
          </>
      )
    },
    {
      title: '状态',
      dataIndex: 'stateDisplay',
      key: 'stateDisplay',
      width:120,
      render: (val,record) => (
          <>
            {
              val?<Tag color={stateColorFn(record?.state)}>{val||""}</Tag>:null
            }
          </>
      )
    },
    {
      title: '操作',
      dataIndex: 'actions',
      width: 150,
      render: 'actionRender',
      fixed: 'right',
    },
  ],
  footer: false,
  search: false,
}
